import * as React from 'react';

const TelegramIcon = () => (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.9598 1.08122L11.8473 11.0437C11.688 11.7468 11.2723 11.9218 10.6817 11.5906L7.46297 9.21872L5.90984 10.7125C5.73797 10.8843 5.59422 11.0281 5.26297 11.0281L5.49422 7.74997L11.4598 2.35934C11.7192 2.12809 11.4036 1.99997 11.0567 2.23122L3.68172 6.87497L0.506716 5.88122C-0.183909 5.66559 -0.196409 5.19059 0.650466 4.85934L13.0692 0.0749699C13.6442 -0.140655 14.1473 0.203095 13.9598 1.08122Z"
            fill="#57FF67"
        />
    </svg>
);

export default TelegramIcon;
